var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchExams__not-found"},[_c('div',{staticClass:"searchExams__not-found--icon"},[_c('BeakerSvg')],1),_c('p',{staticClass:"searchExams__not-found--title"},[_vm._v("É isso mesmo?")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"searchExams__not-found--subtitle"},[_vm._v(" Não encontrei o serviço que procurou."),_c('br'),_vm._v("Confira se o nome está correto. ")])
}]

export { render, staticRenderFns }